import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CHEMICAL_PRICE_MAX_FRACTIONS,
  CHEMICAL_PRICE_RANGE,
} from "../chemicalLibrary.constants";

import InputWithText from "../../../common/styles/components/inputs/InputWithText";
import CustomTooltip from "../../../common/styles/components/tooltip/CustomTooltip";

import { convertUptoDigits } from "../../../utils/appUtils";

const getDisplayPriceValue = (price) => {
  if (price === null || price === undefined) {
    return "";
  }

  const stringValue = String(price).trim();
  if (stringValue === "") {
    return "";
  }

  return convertUptoDigits(stringValue, CHEMICAL_PRICE_MAX_FRACTIONS);
};

const ChemicalPlantCostRenderer = (params) => {
  const { data, context } = params;
  const [errMessage, setErrMessage] = useState(null);
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation();

  const { min, max } = CHEMICAL_PRICE_RANGE;

  const validate = useCallback(
    (value) => {
      let message = null;
      if (!value) {
        message = t("ValueStrings.requiredField");
      } else if (value < min || value > max) {
        message = t("chemicalLibrary.priceOutOfRangeError", {
          min,
          max,
        });
      }
      setErrMessage(message);
      setIsError(Boolean(message));
      return Boolean(message);
    },
    [t],
  );

  const handleInputBlur = ({ target }) => {
    const { value } = target;
    const hasError = validate(value);
    const hasChanged = parseFloat(value) !== parseFloat(data.price);
    if (context.onChemicalDataChange && hasChanged) {
      context.onChemicalDataChange({
        id: data.id,
        tempChemicalId: data.tempChemicalId,
        price: value,
        hasError,
      });
    }
  };

  const value = useMemo(() => {
    return getDisplayPriceValue(data.price);
  }, [data.price]);

  useEffect(() => {
    validate(data.price);
  }, [data.price, validate]);

  return (
    <CustomTooltip text={errMessage} type="error">
      <div className="cost-input-container">
        <InputWithText
          type="number"
          id={`checmical_cost_input_${data.id}`}
          name={`checmical_cost_input_${data.id}`}
          value={value}
          onBlur={handleInputBlur}
          isError={isError}
        />
      </div>
    </CustomTooltip>
  );
};

export default ChemicalPlantCostRenderer;
